import clearAllCookies from './clearAllCookies';
import { cookieUtils } from './cookiesUtils';
import { oneSignalLogout } from './oneSignalUtils';
import { localStorageUtils } from './localStorageUtils';

async function logoutHandler() {
    const cookies = cookieUtils.getCookies();
    const role = cookies?.user?.role;

    clearAllCookies();
    localStorageUtils.clearAllLocalStorage();

    await oneSignalLogout();

    if (role === 'masseuse') {
        window.location.href = '/auth-therapist';
    } else if (role === 'admin') {
        window.location.href = '/auth';
    } else {
        window.location.href = '/';
    }
}

export default logoutHandler;
